module.exports = __webpack_public_path__ + "img/dometic_tropicool_tcx_35.ee2ae390.png";